import { Helmet } from 'react-helmet-async';
import Login from '../Login';
import LoginSso from './LoginSso';

type LoginPageProps = { isSso?: boolean };

export default function LoginPage({ isSso = false }: LoginPageProps) {
  return (
    <>
      <Helmet>
        <title>DISGENET: Login</title>
        <meta name="description" content="Login to your DISGENET account." />
      </Helmet>
      <div>{isSso ? <LoginSso /> : <Login />}</div>
    </>
  );
}
